'use es6';

import PropTypes from 'prop-types';

/*
  Only include props that are shared between validator components.
*/
export const propTypes = {
  children: PropTypes.node.isRequired,
  validationMessage: PropTypes.object,
  validateDefaultValue: PropTypes.bool,
  trimInputValue: PropTypes.bool,
  onError: PropTypes.func,
  onSuccess: PropTypes.func
};